import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = `${API_URL}/api/energy/devices/energy_devices`

const fetchEcoModeDevices = (access_token: string) => Axios.get(ENDPOINT, {
  headers: {
    'Access-Token': access_token,
  },
})

export default {
  fetchEcoModeDevices,
}
